export default __webpack_public_path__ + "static/media/Vector 76 (2).1621f6b6.svg";